export default {
  nav: {
    dashboard: 'Dashboard',
    teams: 'Teams & Rosters',
    masterManagement: 'League & Player Master',
    videoAnalytics: 'Video & AI Analytics',
    training: 'Skill & Biomechanics',
    recruiting: 'College Recruiting & Scouts',
    playerRecruiting: 'Pro Showcase & Recruiting',
    parentRecruiting: 'College Recruiting Hub',
    lineup: 'Lineup Card',
    liveGame: 'Live Game & Pitch Log',
    events: 'Events & Schedule',
    billing: 'Billing & Stripe Services',
    settings: 'Org Settings',
    management: 'Management',
    adminMenu: 'Team Admin Operations',
    coachMenu: 'Coach Operations',
    playerMenu: 'Player Space',
    parentMenu: 'Family Portal',
    activeContext: 'Active Org Context',
    switchRole: 'View as Role:',
    switchPerspective: 'Switch Perspective',
    signOut: 'Sign Out (Clerk)',
    createJoinOrg: 'Create / Join Organization',
    clerkOrgs: 'Clerk Organizations (Tenants)',
    notifications: 'Notifications',
    playerHub: 'My Player Hub',
    playerRoster: 'Team Roster',
    playerLineup: 'Game Day Lineup',
    playerSchedule: 'Schedule & RSVP',
    playerBilling: 'My Dues & Stripe Payments',
    parentHub: 'Parent Portal',
    parentDirectory: 'Team & Coach Directory',
    parentLogistics: 'Schedule & Transportation',
    parentLineup: 'Game Day Lineup',
    parentBilling: 'Season Dues & Add-ons',
  },
  tenantReg: {
    pageTitle: 'Register Baseball Organization',
    pageSubtitle: 'Register manager credentials and delegate organization provisioning to the backend API server.',
    step1Label: '1. Tenant Manager Account',
    step2Label: '2. Baseball Club / Tenant',
    managerTip: 'Create the primary Tenant Administrator account. This user will have full ownership of organization rosters, subscriptions, and settings.',
    fullName: 'Manager Full Name',
    workEmail: 'Work Email Address (Clerk Login)',
    phoneOptional: 'Phone Number (Optional)',
    password: 'Password',
    alreadyHaveAccount: 'Already have an account? Sign In',
    continueToOrg: 'Continue to Organization Setup',
    orgTip: 'Configure your baseball organization profile. Tenant creation is delegated to and securely provisioned by your API backend server.',
    orgNameLabel: 'Baseball Organization / Club Name',
    typeLabel: 'Tenant Type',
    tierLabel: 'Tenant Type',
    types: {
      PRO: 'Pro',
      AMATEUR: 'Amateur',
      ACADEMIC: 'Academic',
      OTHERS: 'Others',
    },
    orgSlugLabel: 'Organization Slug (URL & Clerk ID)',
    apiSyncNotice: 'Tenant & Clerk organization provisioned by API server',
    backToManager: 'Back to Manager Info',
    createAndLaunch: 'Register & Launch Workspace',
    successTitle: 'Organization Registered!',
    successMsg: 'API server successfully provisioned {org} for manager {user}.',
    sportTypeLabel: 'Sport Type',
    seasonYearLabel: 'Season Year',
    enterCodeLabel: 'Enter 6-Digit Verification Code',
    resendCode: 'Resend Verification Code',
    resendingCode: 'Resending code...',
    verifyContinue: 'Verify & Continue',
    editEmail: 'Edit Email',
    autoFillSocial: 'Auto-fill with Social Account:',
    orEnterCredentials: 'or enter credentials',
    clerkModalBtn: 'Clerk Modal UI',
    passwordPolicyNote: 'Clerk policy requires passwords to be 15+ characters',
    nativeScopingBadge: 'Native Database Scoping',
    selectedBadge: 'Selected',
  },
  master: {
    title: 'League & Player Master Management',
    badge: 'Master DB',
    subtitle: 'Manage master team registry for participated leagues, configure own team status, and link player master records to tenant user accounts for {name}.',
    ownTeamsCount: '{count} Own Teams',
    opponentsCount: '{count} Opponents',
    leagueTeamsTab: 'League Teams Master ({count})',
    playerMasterTab: 'Player Master & User Linkage ({count})',
    searchTeamsPlaceholder: 'Search teams in master or league...',
    addMasterTeam: 'Add Master Team',
    colTeamName: 'Team Name',
    colLeague: 'League / Circuit',
    colDivision: 'Division',
    colCoach: 'Head Coach',
    colDesignation: 'Designation',
    colActions: 'Actions',
    ownClub: 'Own Club',
    opponent: 'Opponent',
    manageRoster: 'Manage Roster',
    scouted: 'Scouted',
    searchPlayersPlaceholder: 'Search player by name, jersey # or email...',
    allTeamsFilter: 'All Teams in Master',
    colJersey: '#',
    colPlayerName: 'Athlete Master Name',
    colPrimaryTeam: 'Primary Team',
    colPosition: 'Position',
    colLinkedUser: 'Linked Tenant User',
    colAccountStatus: 'Account Status',
    colUserLinkage: 'User Linkage',
    notLinked: 'Not Linked to User',
    inviteSentText: 'Invite Sent: {email}',
    linkUserBtn: 'Link User',
    unlinkBtn: 'Unlink',
    sendInviteTitle: 'Send Invite Email',
    unlinkTitle: 'Unlink User Account',
    linkModalTitle: 'Link Player Master to Tenant User Account',
    linkModalEmailLabel: 'Tenant User Account Email (Clerk JWT Login)',
    linkModalEmailDesc: 'When this user logs in with Clerk, their session will automatically bind to this athlete\'s roster, stats, and lineup cards.',
    linkModalSubmit: 'Link Account',
    addTeamModalTitle: 'Register League Master Team',
    addTeamModalNameLabel: 'Team Name',
    addTeamModalNamePlaceholder: 'e.g. Bay Area Bombers 18U',
    addTeamModalLeagueLabel: 'Participated League',
    addTeamModalLeaguePlaceholder: 'e.g. Premier Showcase Circuit',
    addTeamModalDivisionLabel: 'Division',
    addTeamModalDivisionPlaceholder: 'e.g. Varsity Premier',
    addTeamModalCoachLabel: 'Head Coach',
    addTeamModalCoachPlaceholder: 'e.g. Coach Rick Santana',
    addTeamModalDesignationLabel: 'Designation',
    addTeamModalOwnOption: 'Own Club / Team',
    addTeamModalOpponentOption: 'League Opponent Team',
    addTeamModalSubmit: 'Save Master Team',
    markedOwnTeam: 'Marked as Own Team',
    markedOpponent: 'Marked as League Opponent',
    markedDesc: '{name} is now designated as {role}.',
    userLinked: 'Tenant User Linked',
    userLinkedMsg: 'Successfully linked Master Player #{num} {name} to Clerk user account ({email}).',
    userUnlinked: 'User Account Unlinked',
    userUnlinkedMsg: 'Unlinked user credentials from #{num} {name}.',
    inviteDispatched: 'Invitation Dispatched',
    inviteDispatchedMsg: 'Sent tenant onboarding invite to {target}.',
    teamRegistered: 'Team Master Registered',
    teamRegisteredMsg: '{team} registered under {league}',
  },
  roles: {
    admin: 'Team Admin (Elena)',
    coach: 'Coach / Admin',
    player: 'Player (Cole #24)',
    parent: 'Parent (Guardian)',
    ADMIN: 'Tenant Admin',
    COACH: 'Coach',
    GUARDIAN: 'Guardian',
    TEAM_ADMIN: 'Team Admin',
    HEAD_COACH: 'Head Coach',
    ORG_ADMIN: 'Org Admin',
    PLAYER: 'Player',
    PARENT: 'Parent',
  },
  videoAnalytics: {
    title: 'Video Analytics & 4K AI Telestration',
    subtitle: 'High-speed pitch breakdown, exit velocity tracking, and strike zone analysis for {name}',
    bookmarked: 'Clip Bookmarked',
    bookmarkedMsg: 'Saved {title} to your highlight reel.',
  },
  training: {
    title: 'Skill Training & Biomechanics Center',
    subtitle: 'Velocity protocols, weekly homework drills, and movement analysis for {name}',
    weeklyProgramTitle: 'Week 4 Development Program',
    weekProgress: 'Weekly Homework Completed',
    assignedDrills: 'Assigned Homework & Drills',
    done: 'Completed',
    uploadDrillVideo: 'Upload Video Homework',
    drillCompleted: 'Drill Checked Off!',
    homeworkUploaded: 'Video Uploaded',
    homeworkUploadedMsg: 'Your drill video was uploaded and notified to coaching staff.',
  },
  billing: {
    teamAdminTitle: 'Team Billing & Service Subscriptions',
    teamAdminSubtitle: 'Manage Stripe payment models (Team vs Individual) and service subscriptions for {name}',
    memberTitle: 'Payment & Subscription Center',
    memberSubtitle: 'Manage individual season dues, training add-ons, and payment methods via Stripe',
    managingTeam: 'Managing Team Subscription:',
    paymentModelTitle: 'Team Payment Model Configuration',
    paymentModelDesc: 'Select whether team services are billed collectively as a club expense or collected individually from athletes.',
    teamPayment: 'Team Payment (Club Master Billing)',
    teamPaymentDesc: 'All team services and season dues are billed directly to the club master Stripe card.',
    individualPayment: 'Individual Payment (Split Player Dues)',
    individualPaymentDesc: 'Athletes and guardians receive individual Stripe payment links and invoices for dues and selected add-ons.',
    singleStripeInvoice: 'Consolidated Monthly Stripe Invoicing',
    athleteGuardianInvoices: 'Direct Player Portal Self-Payment',
    paymentTypeUpdated: 'Payment Model Updated',
    paymentTypeUpdatedMsg: '{team} set to {type}.',
    servicesCatalog: 'Team Service Subscriptions',
    servicesCatalogSubtitle: 'Activate video analysis, biomechanics training, and recruiting suites for your squad.',
    videoAnalyticsRule: 'Video Analytics is a team-wide infrastructure module and only accepts Team Payment.',
    videoAnalyticsRuleNote: '{name} activated with Team Payment billing.',
    teamOnlyBilling: 'Team Payment Only',
    supportsBilling: 'Supports {type} Billing',
    includedCore: 'Core Platform (Active)',
    manageCancel: 'Cancel / Pause Service',
    subscribeStripe: 'Subscribe via Stripe',
    serviceSubscribed: 'Service Activated',
    serviceSubscribedMsg: '{name} has been enabled for this team.',
    serviceCanceled: 'Subscription Paused',
    serviceCanceledMsg: '{name} will be deactivated at the end of billing period.',
    coreRequired: 'Required Core Feature',
    coreRequiredMsg: 'Baseball Cloud Core is required to maintain rosters and schedule.',
    memberDuesPortal: 'Athlete Account & Billing',
    goodStanding: 'Account in Good Standing',
    enrolledWith: 'Rostered with {team} ({org})',
    seasonDues: '2025 Season Dues',
    individualAddons: 'Individual Athlete Add-on Subscriptions',
    skillTrainingTitle: 'Skill Training & Biomechanics Suite',
    skillTrainingAthleteDesc: 'Personalized throwing velo protocols, hitting homework drills, and coach direct chat.',
    updatePaymentMethod: 'Update Card / Stripe',
    changePaymentMethod: 'Change / Select Payment Method',
    selectPaymentMethod: 'Select Payment Method',
    choosePaymentMethodPrompt: 'Please select a payment method for your organization to activate services and subscriptions.',
    payWithCard: 'Credit / Debit Card (Stripe)',
    payWithCardDesc: 'Instant automatic billing via Visa, Mastercard, AMEX, or JCB.',
    payWithBank: 'Bank Transfer (ACH / Wire / 銀行振込)',
    payWithBankDesc: 'Direct bank debit or domestic wire transfer with automated reconciliation.',
    payWithKonbini: 'Konbini (Convenience Store / コンビニ決済)',
    payWithKonbiniDesc: 'Pay cash at 7-Eleven, Lawson, FamilyMart, Ministop, or Seicomart.',
    manageInStripePortal: 'Manage in Stripe Portal',
    openStripePortal: 'Stripe Customer Portal',
    paymentMethodTitle: 'Master Payment Method (Tenant Admin)',
    paymentMethodSubtitle: 'Club payment method used for team-wide subscriptions, auto-renewals, and add-on services.',
    noCardOnFile: 'No payment method selected yet. Select Credit Card, Bank Transfer, or Konbini to activate subscriptions.',
    cardOnRecord: 'Card on File',
    defaultMethod: 'Default Payment Method',
    activeSubscriptionsTitle: 'Active Organization Subscriptions',
    activeSubscriptionsSubtitle: 'Live subscriptions billed to your tenant Stripe account.',
    noActiveSubs: 'No active subscriptions. Select a plan below to activate services.',
    renewsOn: 'Renews: {date}',
    stripeCustomerId: 'Stripe Customer ID:',
    coveredByTeam: 'Covered by Team Master Subscription',
    proceedToStripe: 'Proceed to Stripe Checkout',
    confirmPaymentMethod: 'Save & Confirm Payment Method',
    videoAnalyticsPlayerNote: 'Your team admin has sponsored Video Analytics. 4K breakdown is unlocked for your profile.',
    accessGranted: 'Full Video Access Enabled',
    paymentHistory: 'Payment & Receipt History',
    stripeModalTitle: 'Secure Stripe Checkout',
    amountDueToday: 'Total Amount Due Today:',
    cardholderName: 'Cardholder Name',
    cardNumber: 'Card Number',
    expiryDate: 'Expiration Date',
    cvc: 'CVC / CVV',
    payWithStripe: 'Pay & Confirm with Stripe',
    paymentSuccess: 'Payment Received!',
    paymentSuccessMsg: 'Successfully processed Stripe payment for {service}. Receipt emailed.',
    coachRestrictionNotice: 'Coach Access: You can manage Team Rosters, Game Lineups, Events, and allocate service seats. To upgrade subscription tiers or modify tenant payment methods, please request assistance from a Tenant Administrator.',
    pendingCancelBadge: 'Pending Cancellation (Active until Period End)',
    resumeBtn: 'Resume Subscription',
    manageSeatsBtn: 'Manage Seat Allocations',
    cancelTeamPlan: 'Cancel Team Plan',
    subscribeTeamPlan: 'Subscribe via Stripe (Team)',
    monthlyDuesLabel: 'Monthly Dues (Forced Monthly Interval):',
    setupRequiredTitle: 'Setup Required: Set Up Stripe Payment Method & Activate Services',
    setupRequiredDesc: 'Welcome to Next Base! Set up your organization payment method (Cards, Bank Transfer, or Konbini via Stripe) and activate service modules below for {org}.',
    stripeCheckoutLaunched: 'Stripe Checkout Launched',
    redirectingToStripe: 'Redirecting to Stripe to confirm {service}...',
    subscriptionActivated: 'Subscription Activated',
    subscriptionActivatedMsg: '{service} has been activated for {org}.',
    loadingStripeElements: 'Loading secure Stripe Elements form...',
    stripeSecure256: 'Official Stripe.js Secure API',
    stripeDirect256: 'Direct 256-bit tokenized checkout via official Stripe.js API',
    customerLabel: 'Customer: {id}',
    paylinkGenTitle: 'Stripe Payment Link Generator',
    paylinkGenSubtitle: 'Share this verified Stripe Checkout URL with athletes or parents to collect seasonal team dues directly.',
    copyBtn: 'Copy',
    doneBtn: 'Done',
  },
  liveGame: {
    title: 'Live Game Day & Pitch Smart Tracker',
    subtitle: 'Real-time pitch count regulation, count tracker, and play logger for {name}',
    topInning: 'Top {inning}',
    botInning: 'Bot {inning}',
    inning: 'Inning {inning}',
    balls: 'Balls',
    strikes: 'Strikes',
    outs: 'Outs',
    atBat: 'At Bat:',
    onDeck: 'On Deck:',
    pitcher: 'Pitcher:',
    pitchCount: 'Pitch Count',
    pitchLimit: 'Pitch Smart Limit: {limit} Pitches',
    restDaysRequired: 'Required Rest: {days} Days',
    quickPlays: 'Quick Play Log',
    ball: '+ Ball',
    strike: '+ Strike (Called/Swinging)',
    foul: 'Foul Ball',
    hitSingle: '1B (Single)',
    hitDouble: '2B (Double)',
    hitTriple: '3B (Triple)',
    homeRun: 'HR (Home Run)',
    strikeout: 'Strikeout (K)',
    walk: 'Walk (BB)',
    outInPlay: 'Out (In Play)',
    runScored: '+ Run Scored',
    advanceInning: 'Next Half-Inning',
    resetCount: 'Reset B/S Count',
    gameLog: 'Live Play-by-Play Stream',
    noPlaysYet: 'No plays recorded yet. Use the action keys above.',
    liveScoreboard: 'Live Scoreboard',
    runnersOnBase: 'Runners on Base',
    clearBases: 'Clear Bases',
    pitchRecorded: 'Pitch Logged',
    pitchRecordedMsg: '{count} pitches logged for {pitcher}',
    pitchLimitWarning: 'Pitch Smart Warning',
    pitchLimitWarningMsg: '{pitcher} has reached {count} pitches ({rest} days rest required).',
  },
  coachDashboard: {
    title: 'Club Overview • Coach Command',
    subtitle: 'Real-time operations for {name}',
    manageTeams: 'Manage Teams',
    activeTeams: 'Active Teams',
    inSeason: '100% In Season',
    activeRoster: 'Active Roster',
    total: 'total',
    scheduledEvents: 'Scheduled Events',
    next7Days: 'Next 7 Days',
    winRate: 'Club Win Rate',
    upcomingGames: 'Upcoming Games & Practices',
    viewAllSchedule: 'View All Schedule',
    clubTeams: 'Club Teams',
    manage: 'Manage',
    confirmed: 'Confirmed',
    out: 'Out',
    pending: 'Pending',
    game: 'GAME',
    practice: 'PRAC',
    coach: 'Coach',
  },
  playerDashboard: {
    welcome: 'Welcome back, {name}!',
    battingAvg: 'Batting Avg',
    exitVelo: 'Exit Velo',
    ops: 'OPS',
    nextGame: 'Next Scheduled Game',
    firstPitch: 'First Pitch in 36h',
    reportTime: 'Report Time',
    reportTimeVal: 'Tomorrow at 3:00 PM',
    uniform: 'Uniform Color',
    location: 'Location',
    attendance: 'Your Attendance:',
    confirmedIn: 'Confirmed (Attending)',
    declinedOut: 'Declined',
    imIn: "I'm In",
    cannotAttend: 'Cannot Attend',
    lineupAssignment: 'Your Lineup Assignment',
    startingLineup: 'Starting Lineup',
    batterHole: '2-Hole Batter',
    posShortstop: 'Position: Shortstop (SS)',
    card: 'Card',
    coachBulletin: "Coach's Bulletin",
    coachQuote: '"Great bullpen sessions this Tuesday. Remember: batting practice starts promptly at 16:30. Bring both game tops."',
    coachAuthor: '— Coach Marcus "Skip" Holloway',
    rsvpSuccess: 'RSVP Confirmed',
    rsvpSuccessMsg: 'You are marked IN for the Championship Game.',
    rsvpDeclined: 'RSVP Declined',
    rsvpDeclinedMsg: 'Coach Holloway notified of your absence.',
  },
  parentDashboard: {
    title: 'Parent Hub • {name}',
    duesPaid: 'Season Dues: Paid in Full',
    enrolledWith: 'Athlete enrolled with {team} ({org})',
    gameDayDest: 'Game Day Destination',
    round1: 'Round 1 Showcase',
    complexAddress: 'Complex Address:',
    dropOff: 'Drop-Off / Arrival:',
    dropOffVal: '90 min prior (15:00)',
    gameUniform: 'Game Uniform:',
    transportConfirmed: 'Transportation & Attendance Confirmed',
    athleteMarked: '{name} is marked as attending by guardian.',
    update: 'Update',
    headCoachContact: 'Head Coach Direct Contact',
    medWaiver: 'Medical & Waiver Status',
    cleared: 'Cleared',
    waiverMsg: '2025 Athletic Physical and Club Liability waivers are verified on file.',
    rsvpSuccess: 'Parent Confirmation Received',
    rsvpSuccessMsg: "{name}'s ride and attendance logged for {event}.",
  },
  teams: {
    title: 'Teams & Divisions',
    subtitle: 'Manage team rosters, coach assignments, and schedules for {name}',
    addNewTeam: 'Add New Team',
    searchPlaceholder: 'Search teams, divisions or coaches...',
    record: 'Record (W-L)',
    rosterSize: 'Roster Size',
    players: 'Players',
    headCoach: 'Head Coach:',
    viewRoster: 'View Roster',
    schedule: 'Team Schedule',
    noTeams: 'No teams found',
    noTeamsDesc: 'No teams registered under the current filter or organization.',
    createFirstTeam: 'Create First Team',
    createModalTitle: 'Create Baseball Team',
    createModalSubtitle: 'Register a new team division under {name}',
    teamName: 'Team Name',
    season: 'Season',
    division: 'Division',
    teamColor: 'Team Color Theme',
    cancel: 'Cancel',
    saveTeam: 'Save Team',
    billingLabel: 'Billing:',
    teamMaster: 'Team Master',
    splitDues: 'Split Dues',
    paymentModel: 'Payment Model',
    teamMasterPayment: 'Team Master Payment',
    individualPlayerDues: 'Individual Player Dues',
    syncWithApi: 'Sync with API',
    stripeBilling: 'Stripe Billing',
    videoAnalyticsSubscribed: 'Video Analytics Subscribed',
    skillTrainingSubscribed: 'Skill Training Subscribed',
    createTeamFailed: 'Create Team Failed',
    teamCreatedSuccess: '{name} created successfully.',
  },
  roster: {
    backToTeams: 'Back to Teams',
    activeAthletes: 'Active Athletes',
    lineupCard: 'Lineup Card',
    addPlayer: 'Add Player',
    seatAllocations: 'Seat Allocations',
    searchPlaceholder: 'Search by name, jersey #, position...',
    allPositions: 'All Positions',
    playerName: 'Player Name',
    primaryPos: 'Primary Pos',
    batsThrows: 'B / T',
    class: 'Class',
    status: 'Status',
    actions: 'Actions',
    viewProfile: 'View Profile',
    noRecords: 'No roster records found matching your filters.',
    addModalTitle: 'Add Player to Roster',
    addModalSubtitle: 'Register athlete for {team}',
    firstName: 'First Name',
    lastName: 'Last Name',
    jersey: 'Jersey #',
    position: 'Position',
    emailOptional: 'Email (Optional)',
    gradYear: 'Graduation Year',
    addAthlete: 'Add Athlete',
    playerAdded: 'Player Added',
    playerAddedMsg: '#{num} {first} {last} joined the roster',
  },
  playerModal: {
    title: 'Athlete Profile & Metrics',
    heightWeight: 'Height / Weight',
    exitVelocity: 'Exit Velocity',
    armVelocity: 'Arm Velocity',
    sprint60: '60-Yard Dash',
    availability: 'Roster Availability Status',
    active: 'Active',
    injured: 'Injured (IL)',
    reserve: 'Reserve',
    contacts: 'Player & Guardian Contact',
    noEmail: 'No email registered',
    scoutingNotes: 'Coach Scouting & Development Notes',
    saveChanges: 'Save Profile Changes',
    profileSaved: 'Athlete Profile Updated',
    profileSavedMsg: 'Metrics and availability saved successfully.',
    bats: 'Bats',
    throws: 'Throws',
    gradClass: 'Class of {year}',
  },
  lineup: {
    title: 'Lineup & Defense Card',
    badge: 'Game Day Prep',
    subtitle: 'Designate 9-hole batting order and defensive positioning for {name}',
    autoFill: 'Auto-Fill',
    saveCard: 'Save Card',
    battingOrder: 'Batting Order',
    starters: '9 Starters',
    selectBatter: '-- Select Batter --',
    defensivePos: 'Defensive Positioning',
    synchronized: 'Synchronized',
    cardSaved: 'Lineup Card Saved',
    cardSavedMsg: 'Official batting order ready for umpire exchange.',
    autoAssigned: 'Auto-Assigned Lineup',
    autoAssignedMsg: 'Filled 9-man order with top active athletes.',
    clickToAssign: 'Click on a position badge below to review starter info.',
    shiftScheme: 'Defensive Shift Scheme:',
    shiftStandard: 'Standard Depth',
    shiftInfieldIn: 'Infield In (Play at Plate)',
    shiftPull: 'RHB Pull Shift',
    shiftNoDoubles: 'No Doubles (Deep)',
    fieldHelp: 'Click any position badge on the diamond above to highlight the assigned athlete and their fielding depth.',
    printLineup: 'Print Lineup Card',
  },
  events: {
    title: 'Events & Schedule',
    subtitle: 'Sync games, practices, and player attendance for {name}',
    scheduleEvent: 'Schedule Event',
    allEvents: 'All Events',
    gamesOnly: 'Games Only',
    practices: 'Practices',
    rollCall: 'Roll Call',
    confirmed: 'Confirmed',
    eventTitle: 'Event Title',
    eventType: 'Event Type',
    homeAway: 'Home / Away',
    opponent: 'Opponent (if game)',
    location: 'Location',
    eventScheduled: 'Event Scheduled',
    eventScheduledMsg: '{title} added to the calendar.',
    attending: 'Attending',
    declined: 'Declined',
    pending: 'Pending',
    saveRollCall: 'Save Roll Call',
    game: 'Game',
    practice: 'Practice',
    scrimmage: 'Scrimmage',
    tryout: 'Tryout',
    home: 'Home',
    away: 'Away',
    syncSchedule: 'Refresh Schedule',
    scheduleEventError: 'Schedule Event Error',
  },
  attendanceModal: {
    title: 'Event Attendance & Roll Call',
    markAllAttending: 'Mark All Attending',
    resetAll: 'Reset All',
    in: 'In',
    out: 'Out',
    maybe: 'Maybe',
    saveAttendance: 'Save Roll Call',
    cancel: 'Cancel',
    successTitle: 'Attendance Updated',
    successMsg: 'Saved roll call status for {title}',
  },
  settings: {
    title: 'Organization Settings',
    subtitle: 'Clerk tenant configuration and multi-tenant parameters for {name}',
    metadata: 'Organization Metadata',
    orgName: 'Organization Name',
    seasonScope: 'Current Season Scope',
    savedMsg: 'Settings updated successfully',
    saveChanges: 'Save Changes',
    apiClerk: 'API & Clerk JWT Interceptor Integration',
    apiClerkDesc: 'Axios automatically forwards Clerk Bearer tokens and X-Organization-Id headers.',
    tabConfig: 'Tenant Configuration',
    tabMembers: 'Member Management & Invitations',
    tabApi: 'API Scoping & Headers',
    membersTitle: 'Tenant Members & RBAC Roles',
    membersSubtitle: 'Manage role permissions (ADMIN, COACH, PLAYER, GUARDIAN) with Last Admin guardrail protection.',
    lastAdminNotice: 'Last Admin Guardrail Active: Minimum 1 Administrator required. Active Admins: {count}',
    softDeletionMode: 'Soft-Deletion / Revocation Mode',
    colMemberName: 'Member Name',
    colEmail: 'Email',
    colAssignedTeam: 'Assigned Team',
    colRole: 'Role (RBAC)',
    colAccess: 'Access Management',
    unassigned: 'Unassigned',
    lastAdminBadge: 'Last Remaining Admin',
    lastAdminTooltip: 'Cannot downgrade role: Organization requires at least one active Tenant Administrator.',
    revokeTooltip: 'Cannot revoke access for the last remaining Tenant Administrator.',
    revokeBtn: 'Revoke Tenant Access',
    revokeConfirm: 'Revoke access for {name}? Any allocated service seats will be returned to the pool.',
    apiScopingTitle: 'Self-Managed Multi-Tenancy Scoping',
    apiScopingSubtitle: 'Attached on every backend API request (/api/v1/...)',
    apiScopingDesc: 'User identity authentication is resolved strictly via Clerk JWT, and organization membership permissions are verified against PostgreSQL models.',
    classificationTier: 'Classification Tier',
    sportType: 'Sport Type',
    seasonYear: 'Season Year',
  },
  seatAllocation: {
    modalTitle: 'Service Seat Allocation',
    modalSubtitle: 'Assign contracted user seats to team athletes and coaches for {service}.',
    utilization: 'Seat Utilization:',
    seatsContracted: '{count} Seats Contracted',
    available: '{count} Available',
    assignSectionTitle: 'Assign Seat to Team Member',
    selectPlaceholder: 'Select athlete or staff member to assign...',
    assignBtn: 'Assign Seat',
    capacityFullWarning: 'Seat capacity full ({total}/{total}). Upgrade plan or revoke unused seats.',
    activeMembersTitle: 'Assigned Active Members ({count})',
    searchPlaceholder: 'Search assigned...',
    colMember: 'Member',
    colRoleJersey: 'Role / Jersey',
    colAssignedDate: 'Assigned Date',
    colAction: 'Action',
    noAssigned: 'No active members assigned to this service yet.',
    unassignBtn: 'Unassign',
    unassignConfirm: 'Revoke seat from {name}? Seat will be returned to pool.',
    ledgerBadge: 'Dynamic PostgreSQL Seat Ledger',
    close: 'Close',
    assignedSuccess: 'Service seat successfully assigned',
    unassignedSuccess: 'Seat unassigned for {name}',
    noServiceAssigned: 'サービスが割り当てられてません',
  },
  capacityExceeded: {
    title: 'Capacity Limit Exceeded',
    badge: '409 Conflict',
    defaultMsg: 'Allocation exceeds contracted seat capacity.',
    contractedSeats: 'Contracted Seats:',
    currentlyAllocated: 'Currently Allocated:',
    requestedAdditional: 'Requested Additional:',
    overage: 'Overage:',
    seatsNeeded: '+{count} seats needed',
    coachNotice: 'As a Coach, you cannot upgrade subscription plans directly. Please contact a Tenant Administrator to expand team seat capacity.',
    cancelBtn: 'Cancel',
    upgradeBtn: 'Upgrade Plan',
  },
  invoices: {
    title: 'Invoice & Payment History',
    subtitle: 'Download PDF tax invoices and inspect payment settlement status across tenant and individual dues.',
    refreshBtn: 'Refresh Invoices',
    tabTenant: 'Tenant Payments',
    tabIndividual: 'Individual Payments',
    colInvoiceNum: 'Invoice #',
    colDate: 'Date',
    colDescription: 'Description',
    colBilledOrg: 'Billed Organization',
    colAthletePayer: 'Athlete / Payer',
    colService: 'Service',
    colAmount: 'Amount',
    colStatus: 'Status',
    colDownload: 'Download',
    noTenantInvoices: 'No tenant payment invoices found.',
    noIndividualInvoices: 'No individual payment invoices recorded.',
    pdfBtn: 'PDF',
  },
  memberInvite: {
    drawerTitle: 'Invite Team Member',
    infoTip: 'Invited members will receive an email to activate their account and join your organization under self-managed tenant scoping.',
    emailLabel: 'Member Work / Personal Email',
    emailPlaceholder: "e.g. coach.smith{'@'}example.com",
    roleLabel: 'Assigned Role (RBAC)',
    teamLabel: 'Assign to Team (Optional)',
    teamPlaceholder: 'Select team assignment...',
    rolePermissions: 'Role Permissions:',
    adminDesc: 'Full access to Tenant Settings, Member Management, Invitations, Service Subscriptions, Billing Customer Portal, and Service Seat Allocation.',
    coachDesc: 'Access to Team Rosters, Game Lineups, Practice/Game Events, and Service Seat Allocation. (Restricted from billing upgrades and payment methods).',
    playerDesc: 'Access to Personal Schedules, RSVPs, Player Profiles, and Individual Dues/Subscriptions.',
    guardianDesc: 'Access to Personal Schedules, RSVPs, Athlete Profiles, and Individual Dues/Subscriptions.',
    cancelBtn: 'Cancel',
    sendBtn: 'Send Invitation',
    successMsg: 'Invitation sent to {email}',
    invalidEmail: 'Please provide a valid recipient email address.',
  },
  common: {
    home: 'HOME',
    away: 'AWAY',
    active: 'ACTIVE',
    injured: 'INJURED',
    reserve: 'RESERVE',
    cancel: 'Cancel',
    save: 'Save',
    sync: 'Sync',
    refresh: 'Refresh',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    loading: 'Loading...',
    actions: 'Actions',
  },
  auth: {
    signInTitle: 'Sign in to Next Base',
    signInSubtitle: 'Access your multi-tenant baseball operations hub',
    clerkAuth: 'Clerk Auth:',
    apiTarget: 'API Target:',
    clientTrustTitle: 'Clerk Bot & Device Trust Verification',
    clientTrustDesc: "Clerk Bot Detection (Cloudflare Turnstile) requires interactive client verification. We have triggered Clerk's secure verification dialog. Once verified, this page will automatically sign you in.",
    dialogNotShowing: 'Dialog not showing?',
    openVerificationModal: 'Open Clerk Verification Modal',
    authNotice: 'Authentication Notice',
    registerNewAccount: 'Register new account →',
    emailLabel: 'Email Address',
    emailPlaceholder: "coach{'@'}diamondacademy.com",
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter your password',
    signInBtn: 'Sign In',
    clerkModalBtn: 'Clerk Modal UI',
    registerNewOrg: 'Register New Baseball Organization',
    authComplete: 'Authentication Complete',
    welcomeBack: 'Welcome back, {name}!',
    missingCreds: 'Missing Credentials',
    missingCredsMsg: 'Please provide both email address and password to sign in.',
    authenticating: 'Authenticating',
    connectingToClerk: 'Connecting to Clerk for {email}...',
    verificationRequired: 'Verification Required',
    verificationChallenge: "Please complete Clerk's bot & device trust challenge in the verification dialog.",
    authFailed: 'Authentication Failed',
    couldNotSignIn: 'Could not sign in with provided credentials.',
    authSuccess: 'Authentication Successful',
    subRequired: 'Subscription Required',
    subRequiredMsg: 'Please activate a team subscription plan to access operations modules.',
    orContinueWith: 'Or continue with',
    orSignUpWith: 'Or sign up with',
  },
  onboarding: {
    joinedOrgTitle: 'Your Joined Organization',
    joinedOrgSubtitle: 'You are authenticated with a single tenant organization.',
    orgType: '{type} Organization',
    enterWorkspace: 'Enter Organization Workspace',
    registerNewOrg: 'Register a New Baseball Organization',
  },
  lineupCard: {
    modalTitle: 'Official Umpire Lineup Card',
    headerBadge: 'Official Lineup Card',
    division: 'Division',
    headCoach: 'Head Coach',
    date: 'Date',
    verified: 'Verified',
    num: 'No.',
    pos: 'Pos',
    managerSig: 'Manager Signature',
    umpireSig: 'Plate Umpire Signature',
    printBtn: 'Print Lineup Card',
  },
  recruitingHub: {
    title: 'NCAA & Pro Showcase Recruiting Hub',
    verifiedBadge: 'NCAA Verified',
    subtitle: 'College scout packets, verified radar leaderboards, and commitment pipeline for {name}',
    commitsBadge: '{count} D1/D2 Commits',
    topExitVelo: 'Top Verified Exit Velo',
    fastest60: 'Fastest 60-Yard Dash',
    avgGpa: 'Average Prospect GPA',
    searchPlaceholder: 'Search athlete, school or position...',
    allGradClasses: 'All Grad Classes',
    class2025: 'Class of 2025 (Seniors)',
    class2026: 'Class of 2026 (Juniors)',
    class2027: 'Class of 2027 (Sophomores)',
    allStatuses: 'All Commitment Statuses',
    uncommittedOnly: 'Uncommitted Only',
    committedOnly: 'Committed',
    colProspect: 'Prospect Name',
    colClass: 'Class',
    colExitVelo: 'Exit Velo',
    colArmVelo: 'Arm Velo',
    colSixty: '60-Yard',
    colGpa: 'GPA',
    colStatusSchool: 'Status & School',
    colScoutPacket: 'Scout Packet',
    uncommittedTag: 'Uncommitted',
    copyLinkTitle: 'Copy Verified Recruiter Link',
    downloadPdfTitle: 'Download 1-Page PDF Profile',
    dossierTitle: 'Verified College Recruiting Dossier',
    peakExitVelo: 'Peak Exit Velo',
    infieldArmVelo: 'Infield / Arm Velo',
    sixtyYardDash: '60-Yard Dash',
    heightWeight: 'Height / Weight',
    recruitingPipeline: 'College Recruiting Pipeline',
    copyRecruiterLink: 'Copy Recruiter Link',
    downloadPdfPacket: 'Download PDF Packet',
    scoutLinkCopied: 'Scout Link Copied',
    scoutLinkCopiedMsg: 'Direct NCAA recruiter link copied for {name}',
    generatingScoutPacket: 'Generating Scout Packet',
    generatingScoutPacketMsg: 'Compiling TrackMan metrics, transcripts, and 4K reel for #{num} {name}...',
  }
};